<template>
    <div class="suggestion-container">
        <feedback-header :title="title" :is-goback="false" @feedback-back="backFn" />
        <div class="suggest-head">
            <p class="suggest-title">您的建议是？</p>
            <p class="suggest-desc">我们期待为您带来最好的服务</p>
            <p class="customer" @click="onlineConsult"><img src="@/assets/images/feedback/CS.png" class="cs-img" /><span>在线客服</span></p>
        </div>
        <div class="suggest-body">
            <p class="body-title">请选择您要建议的功能</p>
            <ul class="suggest-func">
                <li
                    v-for="(item, index) in funcItems"
                    :key="index"
                    class="func-item"
                    :class="{ active: index == current }"
                    @click="selectItem(item, index)"
                >
                    <img :src="index == current ? item.imgSelectedUrl : item.imgUrl" /><span>{{ item.itemText }}</span>
                </li>
            </ul>
            <div class="input-content">
                <textarea v-model="feedbackWords" class="input-text" :placeholder="placeholder" maxlength="200" @input="inputting"></textarea>
                <span class="left-words">{{ inputtedWords }}/200</span>
            </div>
            <feedback-upload ref="feedbackUpload" :title="title" />
            <div class="client-info">
                <input v-model="name" type="text" placeholder="姓名(选填)" maxlength="20" />
                <input v-model="mobile" type="text" placeholder="联系方式(选填)" maxlength="20" />
            </div>
            <div class="link-service">若有问题需要咨询或解决，请联系<span @click="onlineConsult">在线客服</span></div>
            <div class="submit">
                <button type="button" class="btn-submit" :class="activeBtn ? 'btn-active' : ''" @click.prevent="commit">提交</button>
            </div>
        </div>
    </div>
</template>

<script>
import FeedbackHeader from './feedback-header'
import { getCookie } from '../../util/util'
import FeedbackUpload from './feedback-upload'
import getOnlineService from '@/mixins/onlineService/index'

export default {
    components: {
        FeedbackHeader,
        FeedbackUpload
    },
    data() {
        return {
            isLogin: getCookie('loginUser'),
            // eslint-disable-next-line no-undef
            title: _ll('我有建议'),
            // eslint-disable-next-line no-undef
            placeholder: _ll('欢迎您反馈对公众号的使用建议，帮助我们做得更好(必填)'),
            csUrl: '', // 在线客服地址
            feedbackWords: '', // 建议内容
            inputtedWords: 0, // 已输入字数
            current: -1, // 当前选择的功能
            funcItems: [
                {
                    imgUrl: require('@/assets/images/feedback/parcel.png'),
                    imgSelectedUrl: require('@/assets/images/feedback/parcel_w.png'),
                    itemText: '收派服务'
                },
                {
                    imgUrl: require('@/assets/images/feedback/package.png'),
                    imgSelectedUrl: require('@/assets/images/feedback/package_w.png'),
                    itemText: '包装物料'
                },
                {
                    imgUrl: require('@/assets/images/feedback/invoice.png'),
                    imgSelectedUrl: require('@/assets/images/feedback/invoice_w.png'),
                    itemText: '价格发票'
                },
                {
                    imgUrl: require('@/assets/images/feedback/add.png'),
                    imgSelectedUrl: require('@/assets/images/feedback/add_w.png'),
                    itemText: '附加服务'
                },
                {
                    imgUrl: require('@/assets/images/feedback/other.png'),
                    imgSelectedUrl: require('@/assets/images/feedback/other_w.png'),
                    itemText: '其他'
                }
            ],
            name: '',
            mobile: '',
            activeBtn: false,
            typeOne: '建议', // 反馈类型
            typeTwo: '' // 建议功能
        }
    },
    watch: {
        current: function () {
            if (this.current !== -1 && this.inputtedWords !== 0) {
                this.activeBtn = true
            } else {
                this.activeBtn = false
            }
        },
        inputtedWords: function () {
            if (this.current !== -1 && this.inputtedWords !== 0) {
                this.activeBtn = true
            } else {
                this.activeBtn = false
            }
        }
    },
    methods: {
        async onlineConsult() {
            this.csUrl = await getOnlineService()
            window.open(this.csUrl, '_blank')
        },
        // 自定义返回路径
        backFn() {
            this.$router.push({ name: 'feedback' })
        },
        // 输入字数判断
        inputting() {
            this.inputtedWords = this.feedbackWords.length
        },
        // 选择建议的功能
        selectItem(item, index) {
            this.current = index
            this.typeTwo = item.itemText
        },
        commit() {
            if (!this.activeBtn) {
                return
            } // 未激活不可点击
            if (this.isLogin) {
                // 提交前要登录
                // 调用子组件commit方法
                this.$refs.feedbackUpload.postOrUpload({
                    typeOne: this.typeOne, //  一类名称
                    typeTwo: this.typeTwo, //  二类名称
                    typeThree: '', //  三类名称
                    remark: this.feedbackWords, //  功能报障原因
                    name: this.name, //  姓名
                    mobile: this.mobile, //  联系方式
                    channelCode: 'MOBILE.OWF'
                })
            } else {
                this.$router.push({ name: 'login' })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.suggestion-container {
    padding: 0 0.2rem 0.4rem;
    .suggest-head {
        width: 96%;
        height: 1.8rem;
        box-shadow: 0.02rem 0.1rem 0.4rem $gray-light;
        border-radius: 0.2rem;
        margin: 0 auto;
        position: relative;
        padding-left: 0.4rem;
        .suggest-title {
            font-size: 0.4rem;
            padding-top: 0.4rem;
        }
        .suggest-desc {
            font-size: 0.26rem;
            color: $gray;
        }
        .customer {
            position: absolute;
            top: 0.4rem;
            right: 0.2rem;
            width: 1.56rem;
            height: 0.44rem;
            background: $bg-color;
            border-radius: 0.1rem;
            font-size: 0.16rem;
            .cs-img {
                width: 0.3rem;
                margin: 0.1rem;
            }
            span {
                position: absolute;
                top: 0.08rem;
                font-size: 0.22rem;
            }
        }
    }
    .suggest-body {
        margin-top: 0.4rem;
        padding: 0 0.5rem;
        font-size: 0.26rem;
        .body-title {
            color: $gray;
        }
        .suggest-func {
            .func-item {
                display: inline-block;
                width: 46%;
                text-align: center;
                background: $bg-gray;
                margin: 0.1rem 0.2rem 0.1rem 0;
                padding: 0.12rem 0;
                position: relative;
                border-radius: 0.1rem;
                img {
                    width: 0.4rem;
                    height: 0.4rem;
                    position: absolute;
                    top: 50%;
                    margin-top: -0.22rem;
                    left: 0.14rem;
                }
                &.active {
                    color: $white;
                    background: $black;
                }
            }
        }
        .input-content {
            position: relative;
            .left-words {
                position: absolute;
                right: 0.4rem;
                bottom: 0.2rem;
                color: $gray-light;
            }
            .input-text {
                width: 98%;
                min-height: 2.4rem;
                margin-top: 0.3rem;
                padding: 0.2rem 0.24rem;
                border: 1px solid $gray-lighter;
                background: $bg-gray;
                &:empty {
                    &:before {
                        content: attr(placeholder);
                        color: $gray-light;
                    }
                }
                &:focus {
                    &:before {
                        content: none;
                    }
                }
            }
        }
        .client-info {
            input {
                width: 46%;
                margin-right: 0.2rem;
            }
        }
        .link-service {
            font-size: 0.26rem;
            color: $gray;
            margin-top: 0.2rem;
            span {
                color: $link-blue;
            }
        }
        .submit {
            text-align: right;
            margin-top: 0.3rem;
            .btn-submit {
                width: 2.56rem;
                height: 0.96rem;
                color: $bg-color;
                background: $gray;
                border-radius: 0.5rem;
                border: none;
                &.btn-active {
                    background: $red;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/feedback/feedback-suggestion.vue